
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91participant_93Iq0q62gl_BgWYoMTuL7k_7JkCZ9_iSZNHzESB56LNVQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/form/[event]/participant/[participant].vue?macro=true";
import { default as _91event_93YWCutKmaMH3sNphs36rkZF2RcKvDTsceu2KP1__45EgT4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/form/[event].vue?macro=true";
import { default as _91signature_93xPLGEjDstt7QBXBsINaxtDl7SaMGabgdynj0GgmI6loMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/form/signatures/[signature].vue?macro=true";
import { default as formfDtyrIrGxRB7bVOJFIj7b12LY6kRbD4Yn5QeAIAZingMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/form.vue?macro=true";
import { default as index1rkyYLUjGb8Jvvs_45rbA1CcFuPz4ntV9eLG4E7KwpSqEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/index.vue?macro=true";
import { default as mailBaseDataNtE7Saggmhc5Wbj9_lAT6pmdpTIJ7JNClAQhveZmfzsMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/mails/[id]/mailBaseData.vue?macro=true";
import { default as mailActivitiesb_vh4sUCjKbEs0HaOFrWo7aDmQcVAPI19UMYaGWcYJgMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/mails/[id]/mailActivities.vue?macro=true";
import { default as _91id_9330uT7YHlfTd6lMGN1KU4DUQ5Vch7tsH8nTapcMKeGRcMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/mails/[id].vue?macro=true";
import { default as index8hcyMMASBSZKAKFmlixrQHFMz_45Ue2K18pkz3QVmrKSkMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/mails/index.vue?macro=true";
import { default as mailsOY0BcI3KHNPSz5g3oV9MhurtN3aAy2bR94_45N15oijT4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/mails.vue?macro=true";
import { default as eventMailsdIcst0zqOps1Ih2aRjyvSEwKeds1qJrBEu5IrceQEEYMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventMails.vue?macro=true";
import { default as eventLeadersBtWZKDcuVd_GfFjC_wkbycWdzqc4RDnq_YcxcObWyW4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventLeaders.vue?macro=true";
import { default as eventBaseDataVi_EvxCKueKw9MhB1bOAN6GSeMXJ8_vaZ4YLPtYb8pAMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventBaseData.vue?macro=true";
import { default as eventQuestionsk_45fLeQ5br322jxqFI9WCSvYxrx8Ps1ut0BGVmVh_GrQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventQuestions.vue?macro=true";
import { default as eventActivitieswL1inYwtfwE85IZRx6NfWFEqMF2EkoUyB_8R34YY9ggMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventActivities.vue?macro=true";
import { default as eventParticipantsjroyRhbn6v32g0o1MGOt1f8U1VigyvfomKDcpAswA50Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventParticipants.vue?macro=true";
import { default as eventCrisisManagersSOlcBuKGcLGvkqyHPB54G4M59_8giXW4gQFglOaNGdwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventCrisisManagers.vue?macro=true";
import { default as eventParticipantGroupsNnvNAilkhrd4IO2pAfdOWvHINE1u2qT6LBQz05xMHLAMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventParticipantGroups.vue?macro=true";
import { default as eventTemporaryAccessess01iXZvtDkNfDi5nTj5iwfYZS309ANeCOtsNqLZeLoIMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventTemporaryAccesses.vue?macro=true";
import { default as _91id_93u0OCdOXFzH6iyItwJHeHjy_OinpwVhGzOOMkwHQswlgMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id].vue?macro=true";
import { default as indexd2LcdZvAwI37YUiMH4GSaJsMAdtvkDBGUnX6LNRyLzgMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/index.vue?macro=true";
import { default as participantMailsbSoUjhJtHYJsm9Q88lO2jSoOOEf_45zTntdK4nHpWdIgAMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantMails.vue?macro=true";
import { default as participantAnswerszRMr5PkKlrLad9HX_45cig70JL3ePPZlENHm_45mFFyUp6QMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantAnswers.vue?macro=true";
import { default as participantBaseDataQ5qhF3_45ORQWDgD5cj8BhUB0AHMdmg2fX9uXybQnkMJwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantBaseData.vue?macro=true";
import { default as participantGuardiansWAtBcX0CLDvAnoPmK0PS8myPxc7i741pPUeXLqkVI9QMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantGuardians.vue?macro=true";
import { default as participantActivitiesCxMO2jGkJtM7OBaoU9Pc8zBbFT_l3sbqHUYMJGsEWT8Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantActivities.vue?macro=true";
import { default as participantSubmissionsobNoA9c02EmirBcg0ktn_yVm8Ib6J3e2EM3P2BDbxD4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantSubmissions.vue?macro=true";
import { default as participantEmergencyContactsL51vJmJImg4ydkngydBsX8TbQOhxTxovE8RlXpmBzLwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantEmergencyContacts.vue?macro=true";
import { default as participantTemporaryAccesses9wd_6xEbLJFJtIe0KnBgW9sOa60BZvszu9r5_4592ocF4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantTemporaryAccesses.vue?macro=true";
import { default as _91id_93NqNMP_yDPJBo0SE3LJ9m_45VbRcPLWNMxa7PJ6JcKWq_sMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id].vue?macro=true";
import { default as groupBaseDataoers2Y_A8V_qUyuEz4nYlmhGMiKgS5LqTrnEn5npu0UMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participantGroups/[id]/groupBaseData.vue?macro=true";
import { default as groupActivitiesqqr3GjA91eJz0eaIdVdRfY8PcUQU2WnIy9Ra3njpGVIMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participantGroups/[id]/groupActivities.vue?macro=true";
import { default as groupParticipants675xYWxbTaugU1mAAhlfCFuCZhwUdkvFY2Zxgww4z9gMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participantGroups/[id]/groupParticipants.vue?macro=true";
import { default as groupTemporaryAccessesXSNjWfjC73QUM_45i3Ed58ZjsMIoAQXv99PwD1wA2IKX0Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participantGroups/[id]/groupTemporaryAccesses.vue?macro=true";
import { default as _91id_93NxD2RiAmr6K5PPAVUgbmKciWnzLe0MmJ_aBOxAQ34FgMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participantGroups/[id].vue?macro=true";
import { default as eventsRA6q958GympZyLj6eNfAJi_UFTahYOrzZf903SKio00Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events.vue?macro=true";
import { default as rolesKTM0QTYdddFoA_45leYn4iQRsZ7bU_45tsSz3QjJLd3Ra9oMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/roles.vue?macro=true";
import { default as userBaseDatavLbjxxOi3xa7KkqOYFLpS8UM082cq9IrhQiC5Z6Oa20Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/users/[id]/userBaseData.vue?macro=true";
import { default as userActivitiesu0fYMW_aqBEvGNSJVxm9NHZ4I3J4Gvcw0yViyj_45JzAcMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/users/[id]/userActivities.vue?macro=true";
import { default as _91id_93QRDokoEE7BySzq4ZVY3LqO5zv5UnCzvJewlc_45yQKQzUMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/users/[id].vue?macro=true";
import { default as index09I3syJSg52yvSEse_EYpLaYuGz0XFzzcvyYUvPHQ0MMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/users/index.vue?macro=true";
import { default as usersoGpjxTU9xWbFoH6ZmumF2ABq02bXcgFQQy_45MF0XkGw8Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/users.vue?macro=true";
import { default as baseDatarhE6oJymuARr71KBNbXKdnIuAWYsjZGZ3FD3d2Ckfm4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/baseData.vue?macro=true";
import { default as billingsKtnZ_45UzlR1KGAB5qKKdTjIy6Huy15_45bC6_45yWfNA5fpwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/billings.vue?macro=true";
import { default as billingRunsc4Us_45hRLHa745wRjxFCqumifyZOD8Df7OF6uM0MIjAkMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/billingRuns.vue?macro=true";
import { default as organisationUsersIrZJomLu9GBLvi_lkQXpZw2b9c9rRZS3kckg6mTGQwMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/[id]/organisationUsers.vue?macro=true";
import { default as organisationPackagebKRX0HBCmX6seAM5olRP6GEOu8GB3icGlLmaMW65rtwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/[id]/organisationPackage.vue?macro=true";
import { default as organisationBaseData0GzxaC6dEr78YpoWvaRJ_450jv6B1XpYuUcImleI8n4Y8Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationActivitiesUdqBZdJXtViYRKunnnW3R0Rn7ZzUWGj5kTrc9x6lgDEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationSystemDatarjpK2Oplf3SNTRXC9DZDjIJOpJN8yBrHpSU2hrsFyNgMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/[id]/organisationSystemData.vue?macro=true";
import { default as organisationMailSettingsQhl_45Hck1eNQirR4rbs0vCA1mit63gPykVnHDzkpSAwsMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/[id]/organisationMailSettings.vue?macro=true";
import { default as _91id_930qEB_Bp2LIWUvUNxjdW6Pwg4212O7IZeHpKZqOJ3QjoMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/[id].vue?macro=true";
import { default as indexHdPjSlAesuGWSZ4OVcqchQUsBQWN94LuB_4KvcpC7MEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/index.vue?macro=true";
import { default as organisations_XKNzsNutWzUzT6TA28mdWsKh12Ro9PnfZwR6vZBGmMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations.vue?macro=true";
import { default as poolQuestionsqfVIWqUexmQdvoe87cpir5eNVljJKz1JVPz86XtMlO8Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/poolQuestions.vue?macro=true";
import { default as indexrFbtS9KAZ9BhjJI3jRSoMcZQDhIdlFGjuUP5qbn1f4QMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/mailTemplates/index.vue?macro=true";
import { default as mailTemplateBaseDataRAy7vLcxC3WUmWDBKWi09GI4GNwvgjawJVIeCSHhxYIMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as systemDfMOAZiKo_45JHLSHfkQXbcUkJ_45ThChabIhtoT2Ok7HVsMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system.vue?macro=true";
import { default as userBaseDatahbDstmeTRVqSBi_Xh1V9lyWuMYi4ld4T_CaINIzLtPgMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/users/[id]/userBaseData.vue?macro=true";
import { default as userActivitiespn1Ts1kLpsa_WBNw6SNOOngpE8LqlazGaX9B_45mCWzHMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/users/[id]/userActivities.vue?macro=true";
import { default as _91id_93P3fuha4ICGmWiBq4ed7ULTPiZbo7tcwLB_45Yh_45tGjoVYMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/users/[id].vue?macro=true";
import { default as organisationUsersx0cxFQCZ8_45U3L2UoENx250pS8hYQBgI3W7Tvpx2qPfoMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/organisation/organisationUsers.vue?macro=true";
import { default as organisationPackage4kNpyii9PtbSSzhnYvUtXLXjFqumsGJNj2eSVorOTlgMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/organisation/organisationPackage.vue?macro=true";
import { default as organisationBaseDataM2I0t2uTMIlGt17yD76P6X7Aj5GXBwDTKDMV48zo2esMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/organisation/organisationBaseData.vue?macro=true";
import { default as organisationMailSettingsVBc2oLnMppFJTYIMtqR11y_qQsxnowZIn_45kAYssoJHoMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/organisation/organisationMailSettings.vue?macro=true";
import { default as organisationKl9txJ_u_45f2I3kdygMCwxumA0o_45O_1EsqfyFwiQk4i4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/organisation.vue?macro=true";
import { default as mailTemplateBaseDataKEIeI1PnI8lzR4PnXOAwqnQb6aC_JO1epbFggAhFo1cMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as internalGRn1xnTN0Df9CXBRYzji04_45XKtwSslxIu0bWEJgFHAkMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal.vue?macro=true";
import { default as _91id_93T2r5VskNFaRv0Kps6piwDZzQHOlvfx_iUZR8YXeKN7IMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/crisisManagers/[id].vue?macro=true";
import { default as _91id_93F2NM3JRTxZg78a9G8ie5mpVXUK57JKdJ7y9Two8dDSsMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/loginProviders/[id].vue?macro=true";
import { default as index6fO8yLKbzcBrYmVVLM10O85bmfZzeT4iB3EKq3V26mQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/crisisManagers/index.vue?macro=true";
import { default as indexAKRzm8KGN7RsgdGf6s2D3tV79ZiSVvYoO6y3SaUCww8Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/loginProviders/index.vue?macro=true";
import { default as settingsuOKYixVmxHW7zhLgly7u67FdhsvjugVNAVZRd5FioRwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings.vue?macro=true";
import { default as setBaseDatagg3A7c9a7qrq4KaO11mBIjE32GC0FKArvPvz_KkQ0tkMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/questions/sets/[id]/setBaseData.vue?macro=true";
import { default as _91id_93U8VA_45ODi9a9F4l36g_45yMzlnG81fQT5ULCd4NLOWP8u0Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/questions/sets/[id].vue?macro=true";
import { default as index2_8eobKoHQK148nFXkMHYCpvyA8sLNCc7vIPelqXSvEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/questions/sets/index.vue?macro=true";
import { default as setsr87GaXEIdEPpianon7uv_45GIXXaEIv1UJ29Caz9QZpSEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/questions/sets.vue?macro=true";
import { default as questionsmkTTXXe8Bb4sMgBBGGIvwtVXA4mVOUU_458pchQeZ1J4gMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/questions.vue?macro=true";
import { default as indexcrFEyFyv19fBXoLLMRtIyZ1PVTDOnjbSBe1QT3u2HBkMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/auth/index.vue?macro=true";
import { default as inputsIzjH_F4uA7AYBjK7NaGz8R3Lmap0hOXLjlKlOo7UNFsMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/secret/index/inputs.vue?macro=true";
import { default as mosaic5p7hNg2oWpVrxqGvqRLaERXAyduUjOBkVVj3Zalq0hwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/secret/index/mosaic.vue?macro=true";
import { default as dungeonPw1EScsEwW8V0cnTfDfu8m_45bQVUUg6eMfyGE50w3i9UMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/secret/index/dungeon.vue?macro=true";
import { default as componentsVmPzn77BwwwDYZHAJPSHAtBmwCNVKKEz0GPp0QOPOV0Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/secret/index/components.vue?macro=true";
import { default as indexQGWEr4lzTA4tdKvJExIFjKTQlUjK3fvPTCbjnOowXxkMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/secret/index.vue?macro=true";
import { default as registerOOImnwYtRxm1wq1vrkaFetqQufP3eqITadcCsx5GmNEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/auth/register.vue?macro=true";
import { default as _91leader_93YDnF9FC3QguFx8Dul94JQf5RXqoovaZZZyewHClTkIQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/external/event/[event]/leader/[leader].vue?macro=true";
import { default as _91emergency_93qgQqu7LOynZJ1Xqz2gg239lDC0b3QNf7o3DoGljCRlIMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/external/event/[event]/emergency/[emergency].vue?macro=true";
import { default as _91temporary_93HNvaxz4952sjfw1zD8ANwqNawfbdYJbvz3h1aaYfbjoMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/external/event/[event]/temporary/[temporary].vue?macro=true";
import { default as _91event_93f7oqOIAlvEzJlaPdlG8iltZ0Wwe3n_45xtDNk_458s3825sMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/external/event/[event].vue?macro=true";
import { default as eventYoL_4xYFfVd9hvvRSwZErE7FT8Aw6LDGL0eu59JeSK4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/external/event.vue?macro=true";
import { default as indexmoPFEgcbxtgiTzHKnH78oKYDLQQ9xNj66hCLW7Cgv40Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/auth/amos/[organisation]/index.vue?macro=true";
import { default as indexUGL9mE_fMZFWbQLB2FwkCtOIhB5FMb8TCro68prB3eoMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/auth/social/[organisation]/index.vue?macro=true";
export default [
  {
    name: "form",
    path: "/form",
    meta: formfDtyrIrGxRB7bVOJFIj7b12LY6kRbD4Yn5QeAIAZingMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/form.vue"),
    children: [
  {
    name: "form-event",
    path: ":event()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/form/[event].vue"),
    children: [
  {
    name: "form-event-participant-participant",
    path: "participant/:participant()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/form/[event]/participant/[participant].vue")
  }
]
  },
  {
    name: "form-signatures-signature",
    path: "signatures/:signature()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/form/signatures/[signature].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/index.vue")
  },
  {
    name: mailsOY0BcI3KHNPSz5g3oV9MhurtN3aAy2bR94_45N15oijT4Meta?.name,
    path: "/mails",
    meta: mailsOY0BcI3KHNPSz5g3oV9MhurtN3aAy2bR94_45N15oijT4Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/mails.vue"),
    children: [
  {
    name: "mails-id",
    path: ":id()",
    meta: { ...(_91id_9330uT7YHlfTd6lMGN1KU4DUQ5Vch7tsH8nTapcMKeGRcMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/mails/[id].vue"),
    children: [
  {
    name: "mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/mails/[id]/mailBaseData.vue")
  },
  {
    name: "mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/mails/[id]/mailActivities.vue")
  }
]
  },
  {
    name: "mails",
    path: "",
    meta: { ...(index8hcyMMASBSZKAKFmlixrQHFMz_45Ue2K18pkz3QVmrKSkMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/mails/index.vue")
  }
]
  },
  {
    name: eventsRA6q958GympZyLj6eNfAJi_UFTahYOrzZf903SKio00Meta?.name,
    path: "/events",
    meta: eventsRA6q958GympZyLj6eNfAJi_UFTahYOrzZf903SKio00Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events.vue"),
    children: [
  {
    name: "events-id",
    path: ":id()",
    meta: _91id_93u0OCdOXFzH6iyItwJHeHjy_OinpwVhGzOOMkwHQswlgMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id].vue"),
    children: [
  {
    name: "events-id-eventMails",
    path: "eventMails",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventMails.vue")
  },
  {
    name: "events-id-eventLeaders",
    path: "eventLeaders",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventLeaders.vue")
  },
  {
    name: "events-id-eventBaseData",
    path: "eventBaseData",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventBaseData.vue")
  },
  {
    name: "events-id-eventQuestions",
    path: "eventQuestions",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventQuestions.vue")
  },
  {
    name: "events-id-eventActivities",
    path: "eventActivities",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventActivities.vue")
  },
  {
    name: "events-id-eventParticipants",
    path: "eventParticipants",
    meta: eventParticipantsjroyRhbn6v32g0o1MGOt1f8U1VigyvfomKDcpAswA50Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventParticipants.vue")
  },
  {
    name: "events-id-eventCrisisManagers",
    path: "eventCrisisManagers",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventCrisisManagers.vue")
  },
  {
    name: "events-id-eventParticipantGroups",
    path: "eventParticipantGroups",
    meta: eventParticipantGroupsNnvNAilkhrd4IO2pAfdOWvHINE1u2qT6LBQz05xMHLAMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventParticipantGroups.vue")
  },
  {
    name: "events-id-eventTemporaryAccesses",
    path: "eventTemporaryAccesses",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[id]/eventTemporaryAccesses.vue")
  }
]
  },
  {
    name: "events",
    path: "",
    meta: { ...(indexd2LcdZvAwI37YUiMH4GSaJsMAdtvkDBGUnX6LNRyLzgMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/index.vue")
  },
  {
    name: "events-event-participants-id",
    path: ":event()/participants/:id()",
    meta: _91id_93NqNMP_yDPJBo0SE3LJ9m_45VbRcPLWNMxa7PJ6JcKWq_sMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id].vue"),
    children: [
  {
    name: "events-event-participants-id-participantMails",
    path: "participantMails",
    meta: participantMailsbSoUjhJtHYJsm9Q88lO2jSoOOEf_45zTntdK4nHpWdIgAMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantMails.vue")
  },
  {
    name: "events-event-participants-id-participantAnswers",
    path: "participantAnswers",
    meta: participantAnswerszRMr5PkKlrLad9HX_45cig70JL3ePPZlENHm_45mFFyUp6QMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantAnswers.vue")
  },
  {
    name: "events-event-participants-id-participantBaseData",
    path: "participantBaseData",
    meta: participantBaseDataQ5qhF3_45ORQWDgD5cj8BhUB0AHMdmg2fX9uXybQnkMJwMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantBaseData.vue")
  },
  {
    name: "events-event-participants-id-participantGuardians",
    path: "participantGuardians",
    meta: participantGuardiansWAtBcX0CLDvAnoPmK0PS8myPxc7i741pPUeXLqkVI9QMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantGuardians.vue")
  },
  {
    name: "events-event-participants-id-participantActivities",
    path: "participantActivities",
    meta: participantActivitiesCxMO2jGkJtM7OBaoU9Pc8zBbFT_l3sbqHUYMJGsEWT8Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantActivities.vue")
  },
  {
    name: "events-event-participants-id-participantSubmissions",
    path: "participantSubmissions",
    meta: participantSubmissionsobNoA9c02EmirBcg0ktn_yVm8Ib6J3e2EM3P2BDbxD4Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantSubmissions.vue")
  },
  {
    name: "events-event-participants-id-participantEmergencyContacts",
    path: "participantEmergencyContacts",
    meta: participantEmergencyContactsL51vJmJImg4ydkngydBsX8TbQOhxTxovE8RlXpmBzLwMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantEmergencyContacts.vue")
  },
  {
    name: "events-event-participants-id-participantTemporaryAccesses",
    path: "participantTemporaryAccesses",
    meta: participantTemporaryAccesses9wd_6xEbLJFJtIe0KnBgW9sOa60BZvszu9r5_4592ocF4Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participants/[id]/participantTemporaryAccesses.vue")
  }
]
  },
  {
    name: "events-event-participantGroups-id",
    path: ":event()/participantGroups/:id()",
    meta: _91id_93NxD2RiAmr6K5PPAVUgbmKciWnzLe0MmJ_aBOxAQ34FgMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participantGroups/[id].vue"),
    children: [
  {
    name: "events-event-participantGroups-id-groupBaseData",
    path: "groupBaseData",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participantGroups/[id]/groupBaseData.vue")
  },
  {
    name: "events-event-participantGroups-id-groupActivities",
    path: "groupActivities",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participantGroups/[id]/groupActivities.vue")
  },
  {
    name: "events-event-participantGroups-id-groupParticipants",
    path: "groupParticipants",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participantGroups/[id]/groupParticipants.vue")
  },
  {
    name: "events-event-participantGroups-id-groupTemporaryAccesses",
    path: "groupTemporaryAccesses",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/events/[event]/participantGroups/[id]/groupTemporaryAccesses.vue")
  }
]
  }
]
  },
  {
    name: "system",
    path: "/system",
    meta: systemDfMOAZiKo_45JHLSHfkQXbcUkJ_45ThChabIhtoT2Ok7HVsMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system.vue"),
    children: [
  {
    name: "system-roles",
    path: "roles",
    meta: rolesKTM0QTYdddFoA_45leYn4iQRsZ7bU_45tsSz3QjJLd3Ra9oMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/roles.vue")
  },
  {
    name: usersoGpjxTU9xWbFoH6ZmumF2ABq02bXcgFQQy_45MF0XkGw8Meta?.name,
    path: "users",
    meta: usersoGpjxTU9xWbFoH6ZmumF2ABq02bXcgFQQy_45MF0XkGw8Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/users.vue"),
    children: [
  {
    name: "system-users-id",
    path: ":id()",
    meta: { ...(_91id_93QRDokoEE7BySzq4ZVY3LqO5zv5UnCzvJewlc_45yQKQzUMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/users/[id].vue"),
    children: [
  {
    name: "system-users-id-userBaseData",
    path: "userBaseData",
    meta: userBaseDatavLbjxxOi3xa7KkqOYFLpS8UM082cq9IrhQiC5Z6Oa20Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/users/[id]/userBaseData.vue")
  },
  {
    name: "system-users-id-userActivities",
    path: "userActivities",
    meta: userActivitiesu0fYMW_aqBEvGNSJVxm9NHZ4I3J4Gvcw0yViyj_45JzAcMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/users/[id]/userActivities.vue")
  }
]
  },
  {
    name: "system-users",
    path: "",
    meta: { ...(index09I3syJSg52yvSEse_EYpLaYuGz0XFzzcvyYUvPHQ0MMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/users/index.vue")
  }
]
  },
  {
    name: "system-baseData",
    path: "baseData",
    meta: baseDatarhE6oJymuARr71KBNbXKdnIuAWYsjZGZ3FD3d2Ckfm4Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/baseData.vue")
  },
  {
    name: "system-billings",
    path: "billings",
    meta: billingsKtnZ_45UzlR1KGAB5qKKdTjIy6Huy15_45bC6_45yWfNA5fpwMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/billings.vue")
  },
  {
    name: "system-billingRuns",
    path: "billingRuns",
    meta: billingRunsc4Us_45hRLHa745wRjxFCqumifyZOD8Df7OF6uM0MIjAkMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/billingRuns.vue")
  },
  {
    name: organisations_XKNzsNutWzUzT6TA28mdWsKh12Ro9PnfZwR6vZBGmMMeta?.name,
    path: "organisations",
    meta: organisations_XKNzsNutWzUzT6TA28mdWsKh12Ro9PnfZwR6vZBGmMMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations.vue"),
    children: [
  {
    name: "system-organisations-id",
    path: ":id()",
    meta: { ...(_91id_930qEB_Bp2LIWUvUNxjdW6Pwg4212O7IZeHpKZqOJ3QjoMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/[id].vue"),
    children: [
  {
    name: "system-organisations-id-organisationUsers",
    path: "organisationUsers",
    meta: organisationUsersIrZJomLu9GBLvi_lkQXpZw2b9c9rRZS3kckg6mTGQwMMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/[id]/organisationUsers.vue")
  },
  {
    name: "system-organisations-id-organisationPackage",
    path: "organisationPackage",
    meta: organisationPackagebKRX0HBCmX6seAM5olRP6GEOu8GB3icGlLmaMW65rtwMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/[id]/organisationPackage.vue")
  },
  {
    name: "system-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    meta: organisationBaseData0GzxaC6dEr78YpoWvaRJ_450jv6B1XpYuUcImleI8n4Y8Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "system-organisations-id-organisationActivities",
    path: "organisationActivities",
    meta: organisationActivitiesUdqBZdJXtViYRKunnnW3R0Rn7ZzUWGj5kTrc9x6lgDEMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "system-organisations-id-organisationSystemData",
    path: "organisationSystemData",
    meta: organisationSystemDatarjpK2Oplf3SNTRXC9DZDjIJOpJN8yBrHpSU2hrsFyNgMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/[id]/organisationSystemData.vue")
  },
  {
    name: "system-organisations-id-organisationMailSettings",
    path: "organisationMailSettings",
    meta: organisationMailSettingsQhl_45Hck1eNQirR4rbs0vCA1mit63gPykVnHDzkpSAwsMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/[id]/organisationMailSettings.vue")
  }
]
  },
  {
    name: "system-organisations",
    path: "",
    meta: { ...(indexHdPjSlAesuGWSZ4OVcqchQUsBQWN94LuB_4KvcpC7MEMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/organisations/index.vue")
  }
]
  },
  {
    name: "system-poolQuestions",
    path: "poolQuestions",
    meta: poolQuestionsqfVIWqUexmQdvoe87cpir5eNVljJKz1JVPz86XtMlO8Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/poolQuestions.vue")
  },
  {
    name: "system-mailTemplates",
    path: "mailTemplates",
    meta: { ...(indexrFbtS9KAZ9BhjJI3jRSoMcZQDhIdlFGjuUP5qbn1f4QMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/mailTemplates/index.vue")
  },
  {
    name: "system-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplates/:id()/mailTemplateBaseData",
    meta: { ...(mailTemplateBaseDataRAy7vLcxC3WUmWDBKWi09GI4GNwvgjawJVIeCSHhxYIMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/system/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsuOKYixVmxHW7zhLgly7u67FdhsvjugVNAVZRd5FioRwMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings.vue"),
    children: [
  {
    name: "settings-internal",
    path: "internal",
    meta: internalGRn1xnTN0Df9CXBRYzji04_45XKtwSslxIu0bWEJgFHAkMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal.vue"),
    children: [
  {
    name: "settings-internal-users-id",
    path: "users/:id()",
    meta: { ...(_91id_93P3fuha4ICGmWiBq4ed7ULTPiZbo7tcwLB_45Yh_45tGjoVYMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/users/[id].vue"),
    children: [
  {
    name: "settings-internal-users-id-userBaseData",
    path: "userBaseData",
    meta: userBaseDatahbDstmeTRVqSBi_Xh1V9lyWuMYi4ld4T_CaINIzLtPgMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-internal-users-id-userActivities",
    path: "userActivities",
    meta: userActivitiespn1Ts1kLpsa_WBNw6SNOOngpE8LqlazGaX9B_45mCWzHMMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/users/[id]/userActivities.vue")
  }
]
  },
  {
    name: "settings-internal-organisation",
    path: "organisation",
    meta: { ...(organisationKl9txJ_u_45f2I3kdygMCwxumA0o_45O_1EsqfyFwiQk4i4Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/organisation.vue"),
    children: [
  {
    name: "settings-internal-organisation-organisationUsers",
    path: "organisationUsers",
    meta: organisationUsersx0cxFQCZ8_45U3L2UoENx250pS8hYQBgI3W7Tvpx2qPfoMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/organisation/organisationUsers.vue")
  },
  {
    name: "settings-internal-organisation-organisationPackage",
    path: "organisationPackage",
    meta: organisationPackage4kNpyii9PtbSSzhnYvUtXLXjFqumsGJNj2eSVorOTlgMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/organisation/organisationPackage.vue")
  },
  {
    name: "settings-internal-organisation-organisationBaseData",
    path: "organisationBaseData",
    meta: organisationBaseDataM2I0t2uTMIlGt17yD76P6X7Aj5GXBwDTKDMV48zo2esMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/organisation/organisationBaseData.vue")
  },
  {
    name: "settings-internal-organisation-organisationMailSettings",
    path: "organisationMailSettings",
    meta: organisationMailSettingsVBc2oLnMppFJTYIMtqR11y_qQsxnowZIn_45kAYssoJHoMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/organisation/organisationMailSettings.vue")
  }
]
  },
  {
    name: "settings-internal-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplates/:id()/mailTemplateBaseData",
    meta: { ...(mailTemplateBaseDataKEIeI1PnI8lzR4PnXOAwqnQb6aC_JO1epbFggAhFo1cMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/internal/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "settings-crisisManagers-id",
    path: "crisisManagers/:id()",
    meta: { ...(_91id_93T2r5VskNFaRv0Kps6piwDZzQHOlvfx_iUZR8YXeKN7IMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/crisisManagers/[id].vue")
  },
  {
    name: "settings-loginProviders-id",
    path: "loginProviders/:id()",
    meta: { ...(_91id_93F2NM3JRTxZg78a9G8ie5mpVXUK57JKdJ7y9Two8dDSsMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/loginProviders/[id].vue")
  },
  {
    name: "settings-crisisManagers",
    path: "crisisManagers",
    meta: { ...(index6fO8yLKbzcBrYmVVLM10O85bmfZzeT4iB3EKq3V26mQMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/crisisManagers/index.vue")
  },
  {
    name: "settings-loginProviders",
    path: "loginProviders",
    meta: { ...(indexAKRzm8KGN7RsgdGf6s2D3tV79ZiSVvYoO6y3SaUCww8Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: "questions",
    path: "/questions",
    meta: questionsmkTTXXe8Bb4sMgBBGGIvwtVXA4mVOUU_458pchQeZ1J4gMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/questions.vue"),
    children: [
  {
    name: setsr87GaXEIdEPpianon7uv_45GIXXaEIv1UJ29Caz9QZpSEMeta?.name,
    path: "sets",
    meta: setsr87GaXEIdEPpianon7uv_45GIXXaEIv1UJ29Caz9QZpSEMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/questions/sets.vue"),
    children: [
  {
    name: "questions-sets-id",
    path: ":id()",
    meta: { ...(_91id_93U8VA_45ODi9a9F4l36g_45yMzlnG81fQT5ULCd4NLOWP8u0Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/questions/sets/[id].vue"),
    children: [
  {
    name: "questions-sets-id-setBaseData",
    path: "setBaseData",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/questions/sets/[id]/setBaseData.vue")
  }
]
  },
  {
    name: "questions-sets",
    path: "",
    meta: { ...(index2_8eobKoHQK148nFXkMHYCpvyA8sLNCc7vIPelqXSvEMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/questions/sets/index.vue")
  }
]
  }
]
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexcrFEyFyv19fBXoLLMRtIyZ1PVTDOnjbSBe1QT3u2HBkMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/auth/index.vue")
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/secret/index/inputs.vue")
  },
  {
    name: "secret-index-mosaic",
    path: "mosaic",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/secret/index/mosaic.vue")
  },
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-components",
    path: "components",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/secret/index/components.vue")
  }
]
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registerOOImnwYtRxm1wq1vrkaFetqQufP3eqITadcCsx5GmNEMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/auth/register.vue")
  },
  {
    name: "external-event",
    path: "/external/event",
    meta: eventYoL_4xYFfVd9hvvRSwZErE7FT8Aw6LDGL0eu59JeSK4Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/external/event.vue"),
    children: [
  {
    name: "external-event-event",
    path: ":event()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/external/event/[event].vue"),
    children: [
  {
    name: "external-event-event-leader-leader",
    path: "leader/:leader()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/external/event/[event]/leader/[leader].vue")
  },
  {
    name: "external-event-event-emergency-emergency",
    path: "emergency/:emergency()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/external/event/[event]/emergency/[emergency].vue")
  },
  {
    name: "external-event-event-temporary-temporary",
    path: "temporary/:temporary()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/external/event/[event]/temporary/[temporary].vue")
  }
]
  }
]
  },
  {
    name: "auth-amos-organisation",
    path: "/auth/amos/:organisation()",
    meta: indexmoPFEgcbxtgiTzHKnH78oKYDLQQ9xNj66hCLW7Cgv40Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/auth/amos/[organisation]/index.vue")
  },
  {
    name: "auth-social-organisation",
    path: "/auth/social/:organisation()",
    meta: indexUGL9mE_fMZFWbQLB2FwkCtOIhB5FMb8TCro68prB3eoMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82173524/client/pages/auth/social/[organisation]/index.vue")
  }
]